export function isScrollEnd(element: HTMLDivElement) {
  const divSize = element.getBoundingClientRect()
  const scrolledHeight = element.scrollHeight
  if (scrolledHeight - 10 <= element.scrollTop + divSize.height) {
    return true
  }
  return false
}
